<template>
  <div class="education">
    <div class="container">
      <div class="" v-on-scroll="{animation: 'header'}">
        <h3 class="wow">For educators</h3>
        <hr class="wow">
      </div>
      <div class="content">
        <div class="row">
          <div class="col-md-8">
            <div class="text-center" v-on-scroll="{animation: 'left-s'}">
              <img src="@/assets/gvLearning/img/unsplash_7fF0iei80AQ.png" v-on-scroll="{animation: 'slideInLeft'}"
                   alt="eduction" class="wow">
              <div class="row offset-md-4 col-md-3">
                <a href="#" style="top: 0; left: 14px;" class="wow" v-on-scroll="{animation: 'swing'}">
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <span>Join us</span>
                  <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.41406" width="15" height="2" transform="rotate(45 1.41406 0)" fill="white"/>
                    <rect y="19.7988" width="15" height="2" transform="rotate(-45 0 19.7988)" fill="white"/>
                  </svg>
                </a>
              </div>
              <div class="wow" v-on-scroll="{animation: 'desc'}">
                <p>
                  <strong>Become an instructor</strong> . We provide the tools and skills to teach what you love.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right-s">
              <div class="gv"></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/gvLearning/styles.scss";
@import "~@/assets/gvLearning/education.scss";

.swing {
  -webkit-animation: swing;
  animation: swing;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.slideInLeft {
  -webkit-animation: slideInLeft;
  animation: slideInLeft;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}
</style>
